// common/data.js

export const menuList = [
  {
    title: "Menu",
    id: "Dyt8xnbzif",
    access: ["y95968"],
    menus: [
      {
        title: "Dashboard",
        icon: "ri-dashboard-fill",
        route: "dashboard",
      },
      {
        title: "My Schools",
        icon: "ri-building-2-fill",
        route: "mySchools",
        acc: "y95968",
      },
      // {
      //   title: "SchoolRep Dashboard",
      //   icon: "ri-dashboard-fill",
      //   route: "rep-dashboard",
      // },
      // {
      //   title: "Pin Purchase",
      //   icon: "ri-file-paper-2-fill",
      //   route: "pin-purchase",
      // },
      // {
      //   title: "transaction",
      //   icon: "ri-wallet-2-line",
      //   route: "transaction",
      // },
      //Bece
      {
        title: "BECE",
        icon: "ri-booklet-line",
        route: "menu",
        acc: ["y13985"],
        id: "wertyuiouewertyugxbs",
        subchildren: [
          {
            icon: "ri-group-fill",
            title: "Student(s)",
            route: "beceStudents",
            acc: "y13985"
          },
          {
            icon: "ri-book-3-fill",
            title: "CAS",
            route: "beceCas",
            acc: "y13985"
          },
          {
            icon: "ri-survey-fill",
            title: "Attendance",
            route: "beceExamSubject",
            acc: "y13985"
          },
          // {
          //   icon: "ri-user-add-fill",
          //   title: "Register Student",
          //   route: "bece-register",
          // },
          // {
          //   icon: "ri-book-read-fill",
          //   title: "Gazette & Photo Album",
          //   route: "bece-gazette",
          // },
          // {
          //   icon: "ri-list-ordered",
          //   title: "Subject Analysis",
          //   route: "beceSubjectAnalysis",
          // },
        ],
      },
      // //Baice
      {
        title: "BAICE",
        icon: "ri-booklet-line",
        route: "menu",
        acc: "y13985",
        id: "g,msdgbsagsjdv-vysd",
        subchildren: [
          {
            icon: "ri-group-fill",
            title: "Student(s)",
            route: "baice-students",
             acc: "y13985",
          },
          {
            icon: "ri-book-3-fill",
            title: "CAS",
            route: "baice-cas",
             acc: "y13985",
          },
      //     {
      //       icon: "ri-user-add-fill",
      //       title: "Register Student",
      //       route: "baice-register",
      //     },
      //     {
      //       icon: "ri-file-image-line",
      //       title: "Photo Album",
      //       route: "baice-photo_album",
      //     },
      //     {
      //       icon: "ri-book-read-fill",
      //       title: "Gazette Request",
      //       route: "baice-gazette",
      //     },
      //     {
      //       icon: "ri-contacts-book-fill",
      //       title: "Exam Cards",
      //       route: "baice-exam_card",
      //     },
      //     {
      //       icon: "ri-list-ordered",
      //       title: "Subject Analysis",
      //       route: "baice-subject-analysis",
      //     },
        ],
      },
      // //Saiqe
      {
        title: "SAIQE",
        icon: "ri-booklet-line",
        route: "menu",
         acc: "y13985",
        id: "ljdadfjkdgbsagsjdvsd",
        subchildren: [
          {
            icon: "ri-group-fill",
            title: "Student(s)",
            route: "saiqe-students",
             acc: "y13985",
          },
          {
            icon: "ri-book-3-fill",
            title: "CAS",
            route: "saiqe-cas",
             acc: "y13985",
          },
      //     {
      //       icon: "ri-user-add-fill",
      //       title: "Register Student",
      //       route: "saiqe-register",
      //     },
      //     {
      //       icon: "ri-file-image-line",
      //       title: "Photo Album",
      //       route: "saiqe-photo_album",
      //     },
      //     {
      //       icon: "ri-book-read-fill",
      //       title: "Gazette Request",
      //       route: "saiqe-gazette",
      //     },
      //     {
      //       icon: "ri-contacts-book-fill",
      //       title: "Exam Cards",
      //       route: "saiqe-exam_card",
      //     },
      //     {
      //       icon: "ri-list-ordered",
      //       title: "Subject Analysis",
      //       route: "saiqe-subject-analysis",
      //     },
        ],
      },
      //qe
      {
        title: "QE",
        icon: "ri-booklet-line",
        route: "menu",
        id: "bjdfdsdgbhsdfbds",
        subchildren: [
          {
            icon: "ri-group-fill",
            title: "Student(s)",
            route: "qe-students",
          },
          {
            icon: "ri-book-3-fill",
            title: "CAS",
            route: "qe-cas",
          },
      //     {
      //       icon: "ri-user-add-fill",
      //       title: "Register Student",
      //       route: "qe-register",
      //     },
      //     {
      //       icon: "ri-file-image-line",
      //       title: "Photo Album",
      //       route: "qe-photo_album",
      //     },
      //     {
      //       icon: "ri-book-read-fill",
      //       title: "Gazette Request",
      //       route: "qe-gazette",
      //     },
      //     {
      //       icon: "ri-contacts-book-fill",
      //       title: "Exam Cards",
      //       route: "qe-exam_card",
      //     },
      //     {
      //       icon: "ri-list-ordered",
      //       title: "Subject Analysis",
      //       route: "qe-subject-analysis",
      //     },
        ],
      },
    ],
  },
];
